import { render } from "./ErrorPanel.vue?vue&type=template&id=448b01cc&scoped=true&lang=true"
import script from "./ErrorPanel.vue?vue&type=script&lang=js"
export * from "./ErrorPanel.vue?vue&type=script&lang=js"

import "./ErrorPanel.vue?vue&type=style&index=0&id=448b01cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-448b01cc"]])

export default __exports__